let cachedBaseUrl: string | null = null;

/**
 * Get the base URL for the application based on deployment type
 */
export function getBaseUrl(): string {
	if (cachedBaseUrl === null) {
		const deploymentType = import.meta.env["VITE_DEPLOYMENT_TYPE"] as string;
		cachedBaseUrl =
			deploymentType?.trim() === "internal" ? "/quotemgmt-ui" : "";
	}
	return cachedBaseUrl;
}
